export const MONTHLY_RENT_MAX_DOLLARS = 50_000

export function parseMoneyAmount(value: string): number | null {
  const trimmed = value.trim().replace(/\s/g, '')
  if (!trimmed) return null

  const normalized = trimmed.replace(',', '.')
  if (!/^\d+(\.\d{0,2})?$/.test(normalized)) return null

  const amount = Number.parseFloat(normalized)
  if (!Number.isFinite(amount)) return null

  return Math.round(amount * 100) / 100
}

export function sanitizeMoneyInput(
  value: string,
  maxDollars = MONTHLY_RENT_MAX_DOLLARS
): string {
  const cleaned = value.replace(/\s/g, '').replace(/[^\d,.]/g, '')
  if (!cleaned) return ''

  const separatorIndex = cleaned.search(/[,.]/)
  let integerPart = cleaned
  let decimalPart = ''

  if (separatorIndex >= 0) {
    integerPart = cleaned.slice(0, separatorIndex)
    decimalPart = cleaned.slice(separatorIndex + 1).replace(/[,.]/g, '')
  }

  integerPart = integerPart.replace(/\D/g, '').slice(0, String(maxDollars).length)
  decimalPart = decimalPart.replace(/\D/g, '').slice(0, 2)

  if (!integerPart && !decimalPart) return ''

  const combined = decimalPart ? `${integerPart || '0'}.${decimalPart}` : integerPart
  const amount = parseMoneyAmount(combined)
  if (amount === null) return combined

  if (amount > maxDollars) {
    return String(maxDollars)
  }

  return decimalPart ? `${integerPart || '0'}.${decimalPart}` : integerPart
}

export function digitsOnlyMoney(value: string): string {
  const amount = parseMoneyAmount(sanitizeMoneyInput(value))
  if (amount === null) return ''
  if (Number.isInteger(amount)) return String(amount)
  return amount.toFixed(2)
}

export function formatMoneyDisplay(
  value: string,
  locale = 'fr-CA'
): string {
  const amount = parseMoneyAmount(value)
  if (amount === null) return ''

  const hasCents = !Number.isInteger(amount)
  return amount.toLocaleString(locale, {
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: 2,
  })
}

export function parseMoneyForApi(value: string): string {
  const amount = parseMoneyAmount(value)
  if (amount === null || amount <= 0) return ''
  if (Number.isInteger(amount)) return String(amount)
  return amount.toFixed(2)
}
